import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { EntitySubscriptionContext } from "./EntitySubscriptionContext";

export const useEntitySubscriptionProvider = () => {
  const context = useContext(EntitySubscriptionContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useEntitySubscriptionProvider",
      "EntitySubscriptionContext"
    );
  }

  return context;
};
